import { Injectable } from "@angular/core";
import { Config } from "../../_store/config";

@Injectable({
    providedIn: "root",
})
export class AppConfigService {
    urls = Object.freeze(Config.urls);
    pageSize = Config.pageSize;
    menuItems = Object.freeze(Config.menuItems);
    appName = Object.freeze(Config.appName);

    constructor() {}
}
